import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {RootState} from '../../../../../setup'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import {toast} from 'react-toastify'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import {
  ASSESSMENT_COLUMNS,
  ASSESSMENT_COLUMNS_DATA_MAPPING,
  ASSESSMENT_SORTING_COLUMNS,
} from '../../../Notes/Nurses_Notes/GENERAL_TABLE_CONSTANTS'

const selectTimeZone = (state: RootState) => state.timeZone.timeZone

export default function DeletedNursesAssessmentList() {
  const history = useHistory()
  const [filteredData, setFilteredData] = useState([])
  const [isFetchingData, setIsFetchingData] = useState(true)
  const timeZone = useSelector(selectTimeZone)
  const [searchTerm, setSearchTerm] = useState('')
  const [loadingStates, setLoadingStates] = useState({})
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string, search: string) => {
      setIsFetchingData(true)
      try {
        const response = await axios.get(`/nursesAssessment/getAll?isDeleted=true`, {
          params: {
            page,
            pageSize,
            sortBy,
            sortOrder: sortDir,
            searchTerm: search,
          },
        })
        const {data, currentPage, totalCounts} = response.data
        
        if (!data || !Array.isArray(data)) {
          console.error('Invalid data received:', data)
          setFilteredData([])
          return
        }
        
        const updatedData = data.map((item) => ({
          ...item,
        }))
        setFilteredData(updatedData)
        setQueryData((prevState) => ({
          ...prevState,
          currentPage,
          totalCounts,
        }))
      } catch (error) {
        console.error('Error fetching deleted assessments:', error)
        if (axios.isCancel(error)) {
          console.log('Request canceled', error.message)
        } else {
          console.log('Error: ', error.message)
        }
        setFilteredData([])
      } finally {
        setIsFetchingData(false)
      }
    }

    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm)
  }, [queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm])

  const onUpdate = (row) => {
    history.push(`/deleted-notes/nurses-notes/${row['_id']}`)
  }

  const onView = (row) => {
    history.push(`/deleted-notes/nurses-notes/list/noteEntries/${row.clientId}?noteType=${row.noteType}&nursesAssessmentId=${row._id}`)
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <TableTitle title='Deleted Nursing Assessment'></TableTitle>
        <TableWrapper 
          searchField={
            <TableSearchBar
              label='Search'
              variant='outlined'
              size='small'
              value={searchTerm}
              setQueryData={setQueryData}
              setSearchTerm={setSearchTerm}
              margin='normal'
              inputAdornmentPosition='start'
            ></TableSearchBar>
          }
          dynamicTable={
            <DynamicTable
              htmlColumns={[]}
              columns={ASSESSMENT_COLUMNS}
              data={filteredData}
              canDownload={false}
              canDelete={false}
              canUpdate={true}
              onUpdate={onUpdate}
              canView={true}
              onView={onView}
              setQueryData={setQueryData}
              queryData={queryData}
              columnDataMapping={ASSESSMENT_COLUMNS_DATA_MAPPING}
              sortingColumns={ASSESSMENT_SORTING_COLUMNS}
              tableLoader={isFetchingData}
              loadingStates={loadingStates}
              title='Are you sure you want to delete this Nursing Assessment?'
            />
          }
        />
      </div>
    </div>
  )
}
